// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_l8k","col":"styles_col__6siX1"};